import { connect } from 'react-redux';
import { fromReservation } from 'store/selectors';
import { setActiveDeparture } from 'store/actions';

import { SelectButton } from './SelectButton';

const mapStateToProps = (state, { id }) => {
  const departure = fromReservation.getDeparture(state, id);
  const selected = fromReservation.getActiveDepartureId(state) === id;
  const tabIndex = selected ? -1 : null;
  return {
    selected,
    tabIndex,
    name: departure.routeName,
  };
};
const mapDispatchToProps = (dispatch, { id, selected }) => ({
  onClick: () => selected === id ? null : dispatch(setActiveDeparture(id)),
});

const SelectButtonContainer = connect(mapStateToProps, mapDispatchToProps)(SelectButton);

export { SelectButtonContainer };



// WEBPACK FOOTER //
// ./src/components/organisms/DepartureSelectorGroup/SelectButtonContainer.js